import { ButtonOverrides } from 'baseui/button';
import { StyleOverride } from 'baseui/helpers/overrides';
import stylesColors from 'common/styles/styles.colors';
import * as React from 'react';
import merge from 'ts-deepmerge';

import Button, { ButtonProps } from './button';

interface Props extends Omit<ButtonProps, 'children'> {
  children:
    | React.ReactNode
    | ((color: string, size: number) => React.ReactNode);
  isError?: boolean;
}

export default function IconButton(props: Props) {
  const { variant, isError = false } = props;

  const variantStyle = React.useMemo<StyleOverride>(() => {
    switch (variant) {
      case 'normal':
        return {
          padding: '20px',
          borderRadius: '4px',
        };
      case 'medium':
        return {
          padding: '12px',
          borderRadius: '4px',
        };
      case 'small':
      default:
        return {
          padding: '8px',
          borderRadius: '4px',
        };
    }
  }, [variant]);

  const errorStyles = isError
    ? {
        ':hover': {
          backgroudnColor: stylesColors.redDefault,
        },
      }
    : {};

  const overrides = merge(
    {
      Root: {
        style: {
          width: 'fit-content',
          ...errorStyles,
          ...variantStyle,
        },
      },
      StartEnhancer: {
        style: {},
      },
      EndEnhancer: {
        style: {
          margin: '0px',
        },
      },
    } as ButtonOverrides,
    { ...props.overrides },
  );

  return (
    <Button
      {...props}
      overrides={overrides}
      children={props.isLoading ? null : props.children}
    />
  );
}
